import React, { useState, useEffect } from "react";
import "./SpotifyPage.css";

const SpotifyPage = () => {
  const [tracks, setTracks] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadTracks = async () => {
      try {
        fetch("./My-Spotify-Library.json")
          .then((response) => response.json())
          .then((data) => {
            const validTracks = data
              .filter((track) => track["Track name"])
              .sort(() => Math.random() - 0.5);
            setTracks(validTracks);
            setIsLoading(false);
          })
          .catch((error) => {
            console.error("Error loading JSON:", error);
            setIsLoading(false);
          });
      } catch (error) {
        console.error("Error loading JSON data:", error);
        setIsLoading(false);
      }
    };

    loadTracks();
  }, []);

  if (isLoading) {
    return <div class="loading"></div>;
  }

  return (
    <div className="container">
      <div className="header">
        <h1>My Spotify Library</h1>
        <p>{tracks.length} tracks</p>
      </div>

      <div className="trackListHeader">
        <div className="trackNumber">#</div>
        <div className="trackInfoTitle">TITLE</div>
        <div className="albumNameTitle">ALBUM</div>
      </div>

      <div className="trackList">
        {tracks.map((track, index) => (
          <div
            key={track["Spotify id"] || index}
            className="trackItem"
            style={{
              animationDelay: "0.1s",
            }}
            onClick={() =>
              window.open(
                `https://open.spotify.com/track/${track["Spotify id"]}`
              )
            }
          >
            <div className="trackNumber">{index + 1}</div>
            <div className="trackInfo">
              <div className="trackName">{track["Track name"]}</div>
              <div className="artistName">{track["Artist name"]}</div>
            </div>
            <div className="albumName">{track["Album"]}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SpotifyPage;
